import {
    AddButtonText,
    ContentWrapper,
    DeleteButton,
    StyledAddButton,
} from "./Styled";
import FormType from "../../../../../shared/components/FormType";
import { contactFields } from "../../../../../configs/customer";
import DeleteIcon from "../../../../../shared/svg/DeleteIcon";
import { color } from "../../../../../shared/styles";
import AddSectionIcon from "../../../../../shared/svg/AddSection";
import React, { useContext } from "react";
import { AuthenticationContext } from "../../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../../data/enums";
import { WarningContactPerson } from "../../../create/Content/ContactList/Styled";

interface ContactListProps {
    validated: boolean;
    contactList: any[];
    onChangeContactList: Function;
    onDeleteContact: Function;
    onAddContact: Function;
}

const ContactList = ({
    validated,
    contactList,
    onChangeContactList,
    onDeleteContact,
    onAddContact,
}: ContactListProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canEdit = [ROLE.MANAGER, ROLE.SALE_STAFF].includes(role);

    const getFields = () => {
        return canEdit
            ? contactFields
            : contactFields.map((item) => ({ ...item, disabled: true }));
    };

    return (
        <>
            {contactList.map((contact, index) => (
                <ContentWrapper key={contact.id}>
                    <FormType
                        validationScope={`contact_list.${index}.contact.`}
                        requireData={{
                            ...contact,
                            is_default: contact.contact.is_default,
                            name: contact.contact.name,
                            email: contact.contact.email,
                            phone: contact.contact.phone,
                            position: contact.contact.position,
                        }}
                        mergeFormData={onChangeContactList}
                        title={`Thông tin người liên hệ ${index + 1}`}
                        fields={getFields()}
                        validated={validated}
                        style={{
                            formWrapper: {
                                backgroundColor: "#F7F7F7",
                                borderRadius: "8px",
                                padding: "24px 20px",
                                margin: "20px 20px 0 20px",
                            },
                            contentWrapper: {
                                boxShadow: "none",
                            },
                        }}
                    />

                    <DeleteButton
                        onClick={() => onDeleteContact(contact.id)}
                        disabled={contact.contact.is_default || !canEdit}
                    >
                        <DeleteIcon color={color.secondary.CHARCOAL} />
                    </DeleteButton>
                </ContentWrapper>
            ))}

            {canEdit && (
                <StyledAddButton onClick={() => onAddContact()}>
                    <AddButtonText>Thêm người liên hệ</AddButtonText>
                    <AddSectionIcon />
                </StyledAddButton>
            )}
        </>
    );
};

export default ContactList;
